import { DEFAULT_FILE_SIZE_LIMITS_MB } from './utils/files/fileSizeLimitsDefaults';
import { absoluteUrl } from './utils/url';

export const BASE_SERVER_URL = absoluteUrl(
  import.meta.env.REACT_APP_BASE_SERVER_URL
);

export const ENV_BASE_URL = import.meta.env.REACT_APP_ENV_BASE_URL;
export const POST_DOMAIN_PART = import.meta.env.REACT_APP_POST_DOMAIN;

export const KEYCLOAK_SERVER_URL = absoluteUrl(
  import.meta.env.REACT_APP_KEYCLOAK_SERVER_URL
);

export const KEYCLOAK_REALM_NAME = import.meta.env
  .REACT_APP_KEYCLOAK_REALM_NAME;
export const APP_VERSION = import.meta.env.REACT_APP_VERSION;
export const SENTRY_RELEASE_VERSION =
  import.meta.env.REACT_APP_SENTRY_RELEASE_VERSION;

export const KEYCLOAK_CLIENT_ID = import.meta.env.REACT_APP_KEYCLOAK_CLIENT_ID;

export const IS_ENCRYPTION_ENABLED =
  import.meta.env.REACT_APP_IS_ENCRYPTION_ENABLED?.toLowerCase() === 'true';

export const IS_FILE_COMPRESSION_ENABLED =
  import.meta.env.REACT_APP_IS_FILE_COMPRESSION_ENABLED?.toLowerCase() ===
  'true';

export const IS_NON_AD_ENABLED =
  import.meta.env.REACT_APP_IS_NON_AD_ENABLED?.toLowerCase() === 'true';

export const MICROSOFT_GRAPH_API_URL =
  import.meta.env.REACT_APP_MICROSOFT_GRAPH_API_URL || '';

export const IS_PROVIDERS_DELETION_ALLOWED =
  import.meta.env.REACT_APP_IS_PROVIDERS_DELETION_ALLOWED?.toLowerCase() ===
  'true';

export const TENANT_NAME = import.meta.env.REACT_APP_TENANT_NAME || '';
export const IS_LOGGING_ENABLED =
  import.meta.env.REACT_APP_IS_LOGGING_ENABLED?.toLowerCase() === 'true';

export const IS_MINI_EXPERTS_DISABLED =
  import.meta.env.REACT_APP_IS_MINI_EXPERTS_DISABLED?.toLowerCase() === 'true';

export const IS_WEB_SEARCH_ENABLED =
  import.meta.env.REACT_APP_IS_WEB_SEARCH_ENABLED?.toLowerCase() === 'true';

export const IS_SIGNUP_ENABLED =
  import.meta.env.REACT_APP_IS_SIGNUP_ENABLED?.toLowerCase() === 'true';

export const SPEECH_API_SECRET_KEY =
  import.meta.env.REACT_APP_SPEECH_API_KEY || '';
export const SPEECH_API_REGION =
  import.meta.env.REACT_APP_SPEECH_API_REGION || '';
export const SPEECH_MAX_RECORDING_TIME = import.meta.env
  .REACT_APP_SPEECH_TO_TEXT_MAX_RECORDING_TIME;

export const IS_MTP_DEPLOYMENT =
  import.meta.env.REACT_APP_IS_MTP_DEPLOYMENT?.toLowerCase() === 'true' ||
  false;

export const IS_SELF_SIGNUP_ENABLED =
  import.meta.env.REACT_APP_IS_TRIAL_ENABLED?.toLowerCase() === 'true';

export const RECAPTCHA_SITE_KEY =
  import.meta.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

export const ENCRPT_KEY_B64 = import.meta.env.REACT_APP_ENCRPT_KEY_B64 || '';

export const LOCAL_ENCRPT_KEY_B64 =
  import.meta.env.REACT_APP_LOCAL_ENCRPT_KEY_B64 || '';

export const IS_B_ANALYTICS_TOOL_ENABLED =
  import.meta.env.REACT_APP_IS_ANALYTICS_ENABLED || false;
export const ANALYTICS_HOST = import.meta.env.REACT_APP_ANALYTICS_HOST;
export const ANALYTICS_KEY = import.meta.env.REACT_APP_ANALYTICS_KEY;
export const SHOW_COMPONENT_SHOWCASE =
  import.meta.env.REACT_APP_SHOW_COMPONENT_SHOWCASE?.toLowerCase() === 'true';

export const IS_CAPTCHA_ENABLED =
  import.meta.env.REACT_APP_IS_CAPTCHA_ENABLED?.toLowerCase() === 'true';

export const SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN || '';
export const SENTRY_ENV = import.meta.env.REACT_APP_SENTRY_ENV || '';
export const SENTRY_SEND_DEFAULT_PII =
  import.meta.env.REACT_APP_SENTRY_SEND_DEFAULT_PII?.toLowerCase() === 'true';

export const SENTRY_REPLAYS_SESSION_SAMPLE_RATE =
  import.meta.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || 0.1;

export const SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE =
  import.meta.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || 1.0;

export const SENTRY_TRACE_PROPAGATION_DOMAIN =
  import.meta.env.REACT_APP_SENTRY_TRACE_PROPAGATION_DOMAIN || 'empowergpt.ai';

export const SENTRY_CONSOLE_LOG_LEVELS =
  import.meta.env.REACT_APP_SENTRY_CONSOLE_LOG_LEVELS || 'error';

export const SENTRY_TRACES_SAMPLE_RATE =
  import.meta.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.1;

export const SENTRY_ENABLED =
  import.meta.env.REACT_APP_SENTRY_ENABLED?.toLowerCase() !== 'false';

export const SENTRY_REPLAYS_ENABLED =
  import.meta.env.REACT_APP_SENTRY_REPLAYS_ENABLED?.toLowerCase() === 'true';

export const SENTRY_LOGS_ENABLED =
  import.meta.env.REACT_APP_SENTRY_LOGS_ENABLED?.toLowerCase() === 'true';

export const NO_OF_CONCURRENT_API_CALLS =
  import.meta.env.REACT_APP_NO_OF_CONCURRENT_API_CALLS || 3;
export const MAX_FILES_IN_EACH_API =
  import.meta.env.REACT_APP_MAX_FILES_IN_EACH_API || 25;
export const TOTAL_FILES_MAX_SIZE =
  import.meta.env.REACT_APP_TOTAL_FILES_MAX_SIZE || 100; //MB

export const UPLOAD_SESSION_POLLING_INTERVAL_MS =
  import.meta.env.REACT_APP_UPLOAD_SESSION_POLLING_INTERVAL_MS || 10000;
export const UPLOAD_SESSION_LIST_PAGE_SIZE =
  import.meta.env.REACT_APP_UPLOAD_SESSION_LIST_PAGE_SIZE || 200;
export const ERROR_SESSION_POLLING_INTERVAL_MS =
  import.meta.env.REACT_APP_ERROR_SESSION_POLLING_INTERVAL_MS || 30000;

export const MAX_FILE_SIZE_LIMITS_MB = parseFileSizeLimitsMb();

// Format: "ext.sizeInMb,ext.sizeInMb,..." (e.g. "pdf.300,ppt.300") rather than
// JSON — the deploy pipeline's replace.sh substitutes this value into built
// files via sed, and a JSON blob's quotes/braces/commas don't survive that
// substitution reliably.
function parseFileSizeLimitsMb(): Record<string, number> {
  const raw = import.meta.env.REACT_APP_MAX_FILE_SIZE_LIMITS_MB as
    | string
    | undefined;

  if (!raw) {
    return DEFAULT_FILE_SIZE_LIMITS_MB;
  }

  const parsed: Record<string, number> = {};

  raw.split(',').forEach((entry) => {
    const [extension, sizeMb] = entry.split('.');
    const size = Number(sizeMb);
    if (!extension || !Number.isFinite(size) || size <= 0) {
      throw new Error(
        `REACT_APP_MAX_FILE_SIZE_LIMITS_MB has an invalid entry: "${entry}"`
      );
    }
    parsed[extension.toLowerCase()] = size;
  });

  return parsed;
}
